import { type Context, createContext, type FC, type PropsWithChildren, useContext, useMemo, useState } from 'react'
import { useOneTrustCookieBanner } from './useOneTrustCookieBanner.js'

type ContextProps = {
  isOneTrustLoaded: boolean
  nonce: string
}

export const OneTrustContext: Context<ContextProps> = createContext<ContextProps>({
  isOneTrustLoaded: false,
  nonce: '',
})

export const useOneTrustContext = (): ContextProps => useContext(OneTrustContext)

type Props = {
  id?: string
  nonce: string
  shouldInitalize: boolean
}

export const OneTrustProvider: FC<PropsWithChildren<Props>> = ({ children, id, nonce, shouldInitalize }) => {
  const [isOneTrustLoaded, setIsOneTrustLoaded] = useState<boolean>(false)

  useOneTrustCookieBanner({
    id,
    nonce,
    shouldInitalize,
    onLoad: () => setIsOneTrustLoaded(true),
  })

  const values = useMemo(() => ({ isOneTrustLoaded, nonce }), [isOneTrustLoaded, nonce])

  return <OneTrustContext.Provider value={values}>{children}</OneTrustContext.Provider>
}
